import './styles/main.scss';
import { MobileUtility } from './scripts/features/shared/mobile-utility';
// TODO: Create a bootstrap layer
document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('[data-mobile-toggle]')) {
        new MobileUtility().init();
    }
});
